import React from 'react';

import { ReactComponent as EditIcon } from '../../../assets/icons/edit.svg';
import { ReactComponent as Spinner } from '../../../assets/icons/spinner.svg';
import { getResolvedCardBrandMeta } from './cardBranding';

const CardBrandIcon = ({ brand, number }) => {
  const { key, label, logoSrc } = getResolvedCardBrandMeta({ brand, number });
  const [logoFailed, setLogoFailed] = React.useState(false);

  React.useEffect(() => {
    setLogoFailed(false);
  }, [logoSrc]);

  return (
    <span
      className={`card-brand-badge card-brand-badge--${key} ${logoFailed ? 'card-brand-badge--text' : 'card-brand-badge--logo'}`}
      aria-label={`${label} brand`}
      title={label}
    >
      {!logoFailed && (
        <img
          className="card-brand-badge__image"
          src={logoSrc}
          alt=""
          onError={() => {
            setLogoFailed(true);
          }}
        />
      )}
      {logoFailed && (
        <span className="card-brand-badge__text">{label}</span>
      )}
    </span>
  );
};

const formatCardExpiry = (month, year) => {
  if (!month || !year) return '-- / --';
  const mm = String(month).padStart(2, '0');
  const yy = String(year).slice(-2);
  return `${mm} / ${yy}`;
};

const PaymentMethodCard = ({ setModalVisible, paymentMethod, inModal, cardNumber }) => {
  const openModal = () => {
    if (setModalVisible) setModalVisible(true);
  };
  const card = paymentMethod?.card;
  const hasCard = Boolean(card);
  const holderName = paymentMethod?.billing_details?.name?.trim() || '-';
  const expiryLabel = formatCardExpiry(card?.exp_month, card?.exp_year);

  const content = (
    <>
      {!paymentMethod && (
        <div className="spinner">
          <Spinner />
        </div>
      )}

      {hasCard && (
        <>
          {!inModal && (
            <div className="payment-card-header">
              <h3 className="margin-none payment-card-title">Card</h3>
              {setModalVisible && (
                <button
                  className="btn btn-action"
                  type="button"
                  aria-label="Change card"
                  onClick={openModal}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      openModal();
                    }
                  }}
                >
                  <EditIcon className="icon xs" />
                  <span>Change card</span>
                </button>
              )}
            </div>
          )}

          <div className="payment-card-body">
            <div className="payment-card-display">
              <div className="payment-card-top">
                <div className="card-chip" />
                <CardBrandIcon brand={card?.display_brand || card?.brand} number={cardNumber} />
              </div>
              <div className="payment-card-number">
                **** **** **** {card.last4}
              </div>
            </div>

            <div className="payment-card-meta">
              <div>
                <h4 className="margin-none">Card Holder</h4>
                <p>{holderName}</p>
              </div>
              <div>
                <h4 className="margin-none">Expiry Date</h4>
                <p>{expiryLabel}</p>
              </div>
            </div>
          </div>
        </>
      )}

      {paymentMethod && !hasCard && (
        <p className="payment-card-empty footnote">
          Please contact team@polygraph.net to update your credit card.
        </p>
      )}
    </>
  );

  if (inModal) {
    return (
      <div className="payment-card is-modal">
        <div className="payment-card-inner">
          {content}
        </div>
      </div>
    );
  }

  return (
    <div className="box-gradient payment-card">
      <div className="inner gradient payment-card-inner">
        {content}
      </div>
    </div>
  );
};

export default PaymentMethodCard;
